import { createInvoiceGroup } from '@atlassian/temp-proxies';
import { CommerceAddress } from '@css-xp/graphtypes/src/generated-types-new';
import { CreditCardPaymentMethod, PaymentMethod } from '@atlassian/commerce-payment-methods';
import { Currency } from '@atlassian/cssxp-typescommon';

type InvoiceGroupType = {
  id: string;
  defaultPaymentMethod: {
    id: string;
  };
  shipToParty: {
    id: string;
  };
};

export const getInvoiceGroup = async ({
  transactionAccountId,
  availableInvoiceGroups,
  selectedPaymentMethod,
  currency = Currency.USD,
  selectedSoldToAddress,
}: {
  transactionAccountId: string;
  availableInvoiceGroups: InvoiceGroupType[];
  selectedPaymentMethod: PaymentMethod;
  currency?: Currency;
  selectedSoldToAddress?: CommerceAddress;
}): Promise<{ applicableInvoiceGroupId: string; isRefetchRequired: boolean } | null> => {
  const relatedInvoiceGroupId = availableInvoiceGroups?.find(
    (invoiceGroup: InvoiceGroupType) =>
      invoiceGroup.defaultPaymentMethod?.id === selectedPaymentMethod?.id &&
      invoiceGroup.shipToParty?.id === selectedSoldToAddress?.id
  )?.id;

  if (relatedInvoiceGroupId) {
    return { applicableInvoiceGroupId: relatedInvoiceGroupId, isRefetchRequired: false };
  }

  const getBillingProfileName = () => {
    const { name, city, priceEligibility } = selectedSoldToAddress || {};
    const cardBrand = (selectedPaymentMethod as CreditCardPaymentMethod)?.card?.brand;
    if (name && city && priceEligibility && cardBrand) {
      return `${name} - ${city} (${formatWord(priceEligibility)}) (${currency} - ${formatWord(cardBrand)})`;
    }
    return '-';
  };

  const formatWord = (word?: string | null) => {
    if (!word) {
      return '';
    }
    return (word.charAt(0).toUpperCase() + word.slice(1)).replace('_', ' ');
  };

  const defaultPaymentMethod = selectedPaymentMethod?.id;
  const shipToPartyId = selectedSoldToAddress?.id;

  if (defaultPaymentMethod && shipToPartyId) {
    const createdInvoiceGroupResponse: { id: string } = await createInvoiceGroup({
      transactionAccountId,
      data: {
        name: getBillingProfileName(),
        currency,
        defaultPaymentMethod: defaultPaymentMethod,
        shipToPartyId: shipToPartyId,
      },
    });
    if (createdInvoiceGroupResponse) {
      return {
        applicableInvoiceGroupId: createdInvoiceGroupResponse.id,
        isRefetchRequired: true,
      };
    }
    return null;
  }
  return null;
};
